import React, { createContext, useState, useEffect, useMemo } from "react";
import defaultLogo from "./../images/optimized/logo.webp";
import logo_marzo from "./../images/optimized/lxl-marzo.webp";
import logo_lgbt from "./../images/optimized/lxl-lgbt.webp";
import logo_patrio from "./../images/optimized/lxl-patrio.webp";
import logo_cancer from "./../images/optimized/lxl-cancer.webp";

export const LogoContext = createContext();

const logoData = [
    { 
        url: logo_marzo,
        width: 768,
        height: 768,
        start_date: "2024-03-08T00:00:00-06:00", 
        end_date: "2024-03-31T00:00:00-06:00", 
        color_text: "[#8137F2]", 
        second_color_text: "[#8137F2]", 
        class: "pulse-blue",
        theme: "Día Internacional de la Mujer",
        icon: "💜",
        message: "Celebramos el Día Internacional de la Mujer"
    },
    { 
        url: logo_lgbt,
        width: 768,
        height: 768,
        start_date: "2024-06-10T00:00:00-06:00", 
        end_date: "2024-06-30T00:00:00-06:00", 
        color_text: "white", 
        second_color_text: "white", 
        class: "pulse-rainbow",
        theme: "Mes del Orgullo",
        icon: "🏳️‍🌈",
        message: "Celebramos el Mes del Orgullo LGBTQ+"
    },
    { 
        url: logo_patrio,
        width: 768,
        height: 768,
        start_date: "2024-09-01T00:00:00-06:00", 
        end_date: "2024-09-30T00:00:00-06:00", 
        color_text: "[#006341]", 
        second_color_text: "[#C8102E]", 
        class: "pulse-flag",
        theme: "Mes Patrio",
        icon: "🇲🇽",
        message: "Celebramos las Fiestas Patrias de México"
    },
    { 
        url: logo_cancer,
        width: 500,
        height: 500,
        start_date: "2024-10-18T00:00:00-06:00", 
        end_date: "2024-10-31T00:00:00-06:00", 
        color_text: "[#F3619A]", 
        second_color_text: "[#F3619A]", 
        class: "pulse-pink",
        theme: "Mes de Concientización del Cáncer de Mama",
        icon: "🎀",
        message: "Apoyamos la lucha contra el Cáncer de Mama"
    }
];


export const LogoContextProvider = ({ children }) => {
    const [logoToUse, setLogoToUse] = useState(defaultLogo);
    const [logoDimensions, setLogoDimensions] = useState({ width: 768, height: 494 });
    const [color_text, setColorText] = useState("green");
    const [logo_text, setLogoText] = useState("logo-texto");
    const [color_text_2, setColorText2] = useState("green");
    const [theme, setTheme] = useState(null);
    const [icon, setIcon] = useState(null);
    const [message, setMessage] = useState(null);

    const currentLogo = useMemo(() => {
        const currentDate = new Date();
        return logoData.find(logo => {
            return (
                currentDate.getMonth() === new Date(logo.start_date).getUTCMonth() &&
                currentDate.getDate() >= new Date(logo.start_date).getDate() &&
                currentDate.getDate() <= new Date(logo.end_date).getDate()
            );
        });
    }, []);

    useEffect(() => {
        if (currentLogo) {
            setLogoToUse(currentLogo.url);
            setLogoDimensions({ width: currentLogo.width, height: currentLogo.height });
            setColorText(currentLogo.color_text);
            setLogoText(currentLogo.class);
            setColorText2(currentLogo.second_color_text);
            setTheme(currentLogo.theme);
            setIcon(currentLogo.icon);
            setMessage(currentLogo.message);
        } else {
            setLogoToUse(defaultLogo);
            setLogoDimensions({ width: 768, height: 494 });
            setTheme(null);
            setIcon(null);
            setMessage(null);
        }
    }, [currentLogo]);

    const contextValue = useMemo(() => ({
            logoToUse,
            logoWidth: logoDimensions.width,
            logoHeight: logoDimensions.height,
            color_text,
            logo_text,
            color_text_2,
            theme,
            icon,
            message,
            hasTheme: !!currentLogo
        }), [
            logoToUse,
            logoDimensions,
            color_text,
            logo_text,
            color_text_2,
            theme,
            icon,
            message,
            currentLogo
        ]);

    return (
        <LogoContext.Provider value={contextValue}>
            {children}
            <div className="bg-[#006341]"></div>
            <div className="bg-[#C8102E]"></div>
            <div className="bg-[#8137F2]"></div>
            <div className="bg-[#F3619A]"></div>

        </LogoContext.Provider>
    );
};
